import * as React from "react";

const SvgProviderMapper = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 26 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.2 3.125v6.64a6 6 0 0 0-1.8-.2V4.43l-2.7 1.035v4.863a6 6 0 0 0-1.8 1.553V5.465l-3.6-1.26v10.53l2.34.819v.006c0 .703.12 1.377.343 2.004L7.4 16.31l-4.185 1.62a.81.81 0 0 1-.833-.102.89.89 0 0 1-.382-.753v-12.6a.84.84 0 0 1 .169-.518q.168-.225.461-.337L7.4 2l5.4 1.89 4.185-1.62q.45-.18.832.101a.89.89 0 0 1 .383.754M3.8 15.77l2.7-1.035V4.205l-2.7.9zm15.067 3.03 4.2 4.2.933-.933-4.2-4.2q.4-.5.633-1.15.234-.65.234-1.384 0-1.816-1.259-3.075Q18.15 11 16.333 11q-1.816 0-3.075 1.258Q12 13.518 12 15.333t1.258 3.075q1.26 1.26 3.075 1.259a4.06 4.06 0 0 0 2.534-.867m-.409-1.342a2.9 2.9 0 0 1-2.125.875 2.9 2.9 0 0 1-2.125-.875 2.9 2.9 0 0 1-.875-2.125q0-1.25.875-2.125a2.9 2.9 0 0 1 2.125-.875q1.25 0 2.125.875.876.876.875 2.125 0 1.25-.875 2.125"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgProviderMapper;
